import { mapActions, mapGetters } from 'vuex'

const LayoutElementEditing = {
  data() {
    return {
      isEditing: false,
      settingsOpen: false,
      confirmingDelete: false,
      deleteTimer: null,
      isHovering: false,
      hoverTimer: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapGetters('layoutEditor', ['isShowingLayoutEditUI']),
  },
  watch: {
    // A forced logout closes the sidebar under an open gear menu, which would
    // come back open with the sidebar
    isShowingLayoutEditUI(val) {
      if (!val) this.turnOffEditing()
    },
    // A logout that leaves the sidebar open, like a 403 organization_mismatch,
    // hides the gear without closing its menu
    loggedIn(val) {
      if (!val) this.turnOffEditing()
    },
    settingsOpen(val) {
      if (!val) {
        this.isHovering = false
        this.isEditing = false
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.deleteTimer)
    clearTimeout(this.hoverTimer)
  },
  methods: {
    ...mapActions('layouts', ['updateElement', 'deleteElement']),
    turnOffEditing() {
      this.isEditing = false
      this.settingsOpen = false
    },
    onDelete() {
      if (this.confirmingDelete) {
        clearTimeout(this.deleteTimer)
        this.confirmingDelete = false
        this.deleteElement(this.element)
      } else {
        this.confirmingDelete = true
        this.deleteTimer = setTimeout(() => {
          this.confirmingDelete = false
        }, 3000)
      }
    },
    onMouseEnter() {
      this.isHovering = true
      this.resetHoverTimer()
    },
    onMouseMove() {
      if (!this.isHovering) this.isHovering = true
      this.resetHoverTimer()
    },
    onMouseLeave() {
      if (this.settingsOpen) return
      this.isHovering = false
      clearTimeout(this.hoverTimer)
    },
    resetHoverTimer() {
      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(() => {
        if (!this.settingsOpen) {
          this.isHovering = false
          this.isEditing = false
        }
      }, 5000)
    },
  },
}

export default LayoutElementEditing
